import { Outlet } from "react-router-dom";
import { Layout } from "antd";
import { Content } from "antd/lib/layout/layout";

const BasicLayout = () => {
  return (
    <Layout className="bg-white" style={{ minHeight: "100vh" }}>
      <Content className="flex justify-center items-start">
        <Outlet />
      </Content>
    </Layout>
  );
};

export default BasicLayout;
